import { Cache, ReadonlyCache } from '@luvio/service-cache/v1';
import { Err, err, Ok, ok, Result, SubscribableResult, SyncOrAsync } from '@luvio/utils';

export class CacheControlRequestRunner<ReturnData, NetworkData> {
    returnData: SubscribableResult<ReturnData, Error> | undefined;
    networkData: Ok<NetworkData, Error> | undefined;
    networkError: Err<never, Error> | undefined;
    readFromCacheInternal;
    requestFromNetworkInternal;
    writeToCacheInternal;

    constructor(
        readFromCache: (cache: ReadonlyCache) => SyncOrAsync<SubscribableResult<ReturnData, Error>>,
        requestFromNetwork: () => SyncOrAsync<Result<NetworkData, Error>>,
        writeToCache: (
            cache: Cache,
            networkResult: Result<NetworkData, Error>
        ) => SyncOrAsync<Result<void, Error>>
    ) {
        this.readFromCacheInternal = readFromCache;
        this.requestFromNetworkInternal = requestFromNetwork;
        this.writeToCacheInternal = writeToCache;
    }

    readFromCache(cache: ReadonlyCache) {
        const resultPromise = this.readFromCacheInternal(cache);

        return resultPromise.then((result) => {
            if (result.isErr()) {
                return err(result.error.failure);
            }

            this.returnData = result;
            return ok(undefined);
        });
    }

    requestFromNetwork() {
        const that = this;
        return (async function* () {
            const result = await that.requestFromNetworkInternal();
            if (result.isErr()) {
                that.networkError = result;
            } else {
                that.networkData = result;
            }
            yield result;
        })();
    }

    writeToCache(cache: Cache, networkResult: Result<NetworkData, Error>) {
        return this.writeToCacheInternal(cache, networkResult);
    }
}
